import { graphql } from '@mews-commander/guest-profile';

export const LoyaltyProgramFieldsFragment = graphql(`
    fragment LoyaltyProgramFields on Program {
        code
        createdUtc
        id
        name
        subscription
        type
        updatedUtc
        chainId
    }
`);

export const LoyaltyTierFieldsFragment = graphql(`
    fragment LoyaltyTierFields on Tier {
        code
        createdUtc
        id
        name
        ordering
        programId
        updatedUtc
    }
`);

export const LoyaltyMembershipSummaryFieldsFragment = graphql(`
    fragment LoyaltyMembershipSummaryFields on Membership {
        code
        createdUtc
        id
        isPrimary
        points
        state
        updatedUtc
        program {
            ...LoyaltyProgramFields
        }
        tier {
            ...LoyaltyTierFields
        }
    }
`);
